import { usePipelineTemplatesQuery } from './usePipelineTemplatesQuery';
import { usePipelineTemplatesSearch } from './usePipelineTemplatesSearch';

export const usePipelineTemplates = (filters: Record<string, string> = {}) => {
    const query = usePipelineTemplatesQuery(filters);
    const { keyword } = usePipelineTemplatesSearch();

    const items = query.data?.pages?.flatMap(page =>
        (page && 'items' in page) ? page.items : []
    ) ?? [];

    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    const fetchNextPage = () => {
        if (query.hasNextPage) {
            query.fetchNextPage();
        }
    };

    return {
        items,
        visibleItems,
        loading: query.isLoading,
        nextToken: query.hasNextPage ? 'has-more' : null,
        fetchNextPage,
    };
};
